import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";

import type { CatalogSkill } from "@/components/integrations/skillsCatalog";
import SkillsPage from "./-components/SkillsPage";

/** How long one read of the catalog is served, as `revalidate: 3600` did under Next. */
const CATALOG_TTL_MS = 60 * 60 * 1000;

let catalog: { loadedAt: number; skills: Promise<CatalogSkill[]> } | undefined;

/**
 * The catalog is read from GitHub on the server, never in the browser. A route
 * loader re-runs in the browser on an in-app navigation, where `connect-src`
 * does not list GitHub, so that path was always refused and served the snapshot
 * (R-2207). Held for an hour per process, it also keeps the server well inside
 * GitHub's 60 unauthenticated API requests an hour.
 *
 * `skillsCatalog` is imported inside the handler: a static import survives into
 * the client chunk, and with it the YAML parser and the snapshot.
 */
const getSkillsCatalog = createServerFn({ method: "GET" }).handler(() => {
  if (!catalog || Date.now() - catalog.loadedAt >= CATALOG_TTL_MS) {
    catalog = {
      loadedAt: Date.now(),
      skills: import("@/components/integrations/skillsCatalog").then(
        ({ fetchSkillsCatalog }) => fetchSkillsCatalog()
      ),
    };
  }
  return catalog.skills;
});

export const Route = createFileRoute("/_app/_dashboard/integrations/skills")({
  loader: () => getSkillsCatalog(),
  component: SkillsRoute,
});

function SkillsRoute() {
  return <SkillsPage skills={Route.useLoaderData()} />;
}
